let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aZetx"), load("34i4a"), load("eEyVs"), load("hhss7"), load("i8Yee")]).then(() => parcelRequire('de33F'));